<template>
  <div>
    <el-row>
      <div class="title_left">
        <h3>新增電子簽單</h3>
        <hr />
      </div>
    </el-row>
    <el-row>
      <el-col :span="6" :offset="1">
        <h2 class="col-md-12">請款單: {{ title }}({{ companyName }})</h2>
      </el-col>
      <el-col :span="6">
        <h2 class="col-md-12">
          總張數: {{ tickedCount }} 總金額: ${{ tickedFee }}
        </h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick(activeName)"
        >
          <el-tab-pane label="未放入電子簽單" name="first">
            <el-row>
              <h4 class="col-md-1">時間區間:</h4>
              <el-date-picker
                v-model="time"
                @change="optDate"
                type="daterange"
                range-separator="至"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
              ></el-date-picker>
              <el-button
                type="primary"
                @click="createSigningToInvoice"
                icon="el-icon-document-add"
              >
                電子簽單加入請款單內
              </el-button>
            </el-row>
            <AddSigningListTable
              ref="addSignTable"
              :totalPage="totalPage"
              :task="'add'"
              :signingList="nonTickSigning"
              @searchSigning="searchSigning"
            ></AddSigningListTable>
          </el-tab-pane>
          <el-tab-pane label="已放入的電子簽單" name="second">
            <RemoveSigningListTable
              ref="removeSignTable"
              :task="'remove'"
              :totalPage="tickedTotalPage"
              :signingList="tickedSigning"
              @searchSigning="searchTickedSigning"
              @removeSigningFromInvoice="removeSigningFromInvoice"
            ></RemoveSigningListTable>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'
import AddSigningListTable from '../../components/company/Invoice/AddSigningList'
import RemoveSigningListTable from '../../components/company/Invoice/AddSigningList'

import moment from 'moment'
export default {
  components: {
    AddSigningListTable,
    RemoveSigningListTable,
  },
  data() {
    return {
      tickedCount: 0,
      tickedFee: 0,
      tickedTotalPage: 0,
      tickedPage: 1,
      ticked_pages_show_list: [],
      totalPage: 0,
      page: 1,
      pages_show_list: [],
      historyInvoiceList: [],
      invoiceInfo: {
        enterpriseId: 0,
        companyName: null,
        requestDate: null,
        invoiceNote: null,
        estimatedReceiveDate: null,
        title: null,
        driverReceivePaymentDate: null,
        requestOrderDate: null,
      },
      invoiceId: 0,
      time: '',
      startTime: '',
      endTime: '',
      companyList: [],
      nonTickSigning: [],
      tickedSigning: [],
      tickIdList: [],
      title: '',
      companyName: '',
      enterpriseId: 0,
      activeName: 'first',
    }
  },
  mounted() {
    this.invoiceId = this.$route.query.id
    this.companyName = this.$route.query.companyName
    this.title = this.$route.query.title
    this.enterpriseId = this.$route.query.enterpriseId
    this.getSigningListFromInvoice()
  },
  methods: {
    searchSigning(page) {
      console.log('page', page)
      this.page = page
      this.getSigningList()
    },
    optDate(val) {
      this.startTime = moment(val[0]).format('YYYY-MM-DD')
      this.endTime = moment(val[1]).format('YYYY-MM-DD')
      this.getSigningList(1)
    },
    handleClick(name) {
      console.log(name)
      this.activeName = name
      if (name === 'second') {
        /* console.log('=====') */
        this.getSigningListFromInvoice()
      }
    },
    removeSigningFromInvoice(signingId) {
      let payload = {
        signId: signingId,
        invoiceId: this.invoiceId,
      }
      EnterpriseAPI.put('enterprise/invoice/removesign', payload)
        .then((res) => {
          if (res.success) this.$msg('修改成功')
          this.getSigningListFromInvoice()
        })
        .catch((err) => {
          this.$msg('網路不穩定請再操作一次')
        })
    },
    clickNewPage(page) {
      this.page = page
      this.getSigningList()
    },
    selectEnterpriceId(enterpriseId) {
      let index = this.companyList
        .map((Element) => Element.id)
        .indexOf(enterpriseId)
      this.invoiceInfo.companyName = this.companyList[index].name
    },
    getSigningListFromInvoice() {
      // teamAsk=3(請款單)
      EnterpriseAPI.get(
        `enterprise/signingList?teamAsk=3&day_num=0&enterpriseId=${this.enterpriseId}&npp=25&page=${this.tickedPage}&invoiceId=${this.invoiceId}`,
      )
        .then((res) => {
          this.tickedPage = 1
          if (res.success) {
            let { count, list, totalFee } = res.result
            this.tickedFee = totalFee
            this.tickedCount = count
            this.tickedTotalPage = Math.ceil(count / 25)
            this.tickedSigning = list
            return
          }
          this.$msg(res.result)
          this.count = 0
          this.signing = []
        })
        .catch((err) => {
          this.$msg(err.message)
        })
    },
    getSigningList(teamAsk) {
      // teamAsk=1(未入)/teamAsk=2(已入)
      EnterpriseAPI.get(
        `enterprise/signingList?teamAsk=${teamAsk}&day_num=0&enterpriseId=${this.enterpriseId}&startTime=${this.startTime}&endTime=${this.endTime}&npp=25&page=${this.page}`,
      )
        .then((res) => {
          if (res.success) {
            let { count, list } = res.result
            this.totalPage = Math.ceil(count / 50)
            this.nonTickSigning = list
            return
          }
          this.$msg(res.result)
          this.count = 0
          this.signing = []
        })
        .catch((err) => {
          this.$msg(err.message)
        })
    },
    createSigningToInvoice() {
      this.tickIdList = this.$refs.addSignTable.getMultipSelection()
      if (this.tickIdList.length === 0) return this.$msg('請選擇電子簽單')
      let payload = {
        invoiceId: this.invoiceId,
        nonTickId: '',
        tickId: this.tickIdList.join(','),
      }
      EnterpriseAPI.put('enterprise/invoice/addsign', payload)
        .then((res) => {
          if (res.success) this.$msg('修改成功')
          this.nonTickSigning = []
          this.getSigningList(1)
          this.tickIdList = []
          this.getSigningListFromInvoice()
        })
        .catch((err) => {
          this.$msg('網路不穩定請再操作一次')
        })
    },
    optInvoice(enter) {},
    searchTickedSigning(page) {
      this.tickedPage = page
      this.getSigningListFromInvoice()
    },
  },
}
</script>
<style scoped>
.input-interval {
  margin-right: 5px;
}
.el-row {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/company/AddInvoice.vue